
import './App.css';
// import "./key";
import Axios from 'axios';
import { useState } from 'react';
import Recipe_card from './Recipe_card';

// eslint-disable-next-line 

function App() {
const [query, setquery] = useState("");
const [recipes, setrecipes] = useState([]);
const [healthLabel, sethealthLabel] = useState("vegan");


  let url = `https://api.edamam.com/search?q=${query}&app_id=9a001f9a&app_key=200c8699ee208a26eb9f9d048b8b5a2a&from=0&to30=&health=${healthLabel}`;

  async function getRecipes() {
    var result = await Axios.get(url);
    setrecipes(result.data.hits)
    console.log(result.data);
  }

  const onSubmit = (event) => {
    event.preventDefault();
    getRecipes();
  }

  return (
    <div className="app">
     <h1 >Food Recipe Finder</h1>
     <form className="app__searchForm" onSubmit={onSubmit}>
      <input type="text" 
      className="app__input" 
      placeholder="Enter ingredient"
      value={query} 
      onChange={(event) => setquery(event.target.value)}
      />
      <input className="app__submit" type="submit" value="Search"/>

      <select className="app_healthLabel">
        <option onClick={()=> sethealthLabel("vegan")}value="vegan">Vegan</option>
        <option onClick={()=> sethealthLabel("vegetarian")}value="vegetarian">Vegetarian</option>
        <option onClick={()=> sethealthLabel("paleo")}value="paleo">paleo</option>
        <option onClick={()=> sethealthLabel("dairy-free")}value="dairy-free">Dairy-free</option>
        <option onClick={()=> sethealthLabel("gluten-free")}value="gluten-free">Gluten-free</option>
        <option onClick={()=> sethealthLabel("wheat-free")}value="wheat-free">Wheat-free</option>
        <option onClick={()=> sethealthLabel("low-sugar")}value="low-sugar">Low-sugar</option>
        <option onClick={()=> sethealthLabel("egg-free")}value="egg-free">Egg-free</option>
        <option onClick={()=> sethealthLabel("peanut-free")}value="peanut-free">Peanut-free</option>
        <option onClick={()=> sethealthLabel("tree-nut-free")}value="tree-nut-free">Tree-nut-free</option>
        <option onClick={()=> sethealthLabel("soy-free")}value="soy-free">Soy-free</option>
        <option onClick={()=> sethealthLabel("fish-free")}value="fish-free">Fish-free</option>
        <option onClick={()=> sethealthLabel("shellfish-free")}value="shellfish-free">shellfish-free</option>

      </select>
     </form>

     <div className="app__recipes">
    {recipes.map(recipe => {
      return <Recipe_card recipe={recipe}/>;
    })}
     </div>

    </div>
  );
}

export default App;
